import React, { useContext, useEffect, useState } from 'react';
import './index.scss';
import { Helmet } from 'react-helmet';
import {
  DEFAULT_ZIPCODE,
  DRUG_RESOURCE_SIGNUP_MODAL,
  HOME_CANONICAL
} from '../../../constants/defaults';
import _ from 'lodash';
import SkipTo from '../../common/Tag/SkipTo';
import RelatedList, {
  RELATED_ITEM_SLUG_KEY,
  RELATED_ITEM_SLUG_PREFIX
} from '../../common/RelatedList';
import RelatedArticles from '../../common/RelatedArticles/index.jsx';
import ContentfulFaqs from '../../prescription-2/ContentfulFaqs';
import HomeSignUpv2 from '../../HomeSignUp-v2/index.js';
import { AuthContext } from '../../../Contexts.js';
import SearchBar from '../../SearchBar/index.jsx';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { fetchPrices } from '../../../services/Api/Pricing/dtcPrcing.js';
import loadable from '@loadable/component';
import { useDispatch } from 'react-redux';
import { modalActions } from '../../../reducers/modalSlice.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';
const AuthenticatedModal = loadable(() =>
  import('../../HomeDeliveryNew/AuthenticateModal')
);
const DrugCollectionDetails = props => {
  let data;
  if (typeof window !== 'undefined' && typeof __INITIAL_DATA__ !== 'undefined')
    data = window.__INITIAL_DATA__;
  else data = props.staticContext.data;
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;
  const [loading, setLoading] = useState(true);
  const [isSignupModalOpen, setSignupModal] = useState(false);
  const dispatch = useDispatch();
  const zipcodeValue =
    typeof localStorage !== 'undefined' &&
    localStorage.getItem('zipCodeData') &&
    JSON.parse(localStorage.getItem('zipCodeData')).zipCode;
  const cmsData = {
    cmsData: {
      name: data?.drugCollectionName,
      medicalReviewer: data?.medicalReviewer,
      faqs: JSON.parse(data?.faqs)
    }
  };
  const [drugList, setDrugList] = useState(data?.listOfDrugs || []);
  useEffect(() => {
    getGLPDrugPrices();
  }, []);

  const getGLPDrugPrices = async () => {
    setLoading(true);

    let drugs = drugList.map(drug => ({
      ndc: drug.defaultNdc,
      quantity: drug.quantity
    }));
    try {
      let priceDataResp = await fetchPrices(
        drugs,
        !_.isEmpty(zipcodeValue) ? zipcodeValue : DEFAULT_ZIPCODE
      );
      if (!_.isEmpty(priceDataResp)) {
        // Iterate through each drug in drugList
        drugList.forEach(drug => {
          // Find the corresponding price object in the prices array
          const matchingPrice = priceDataResp.find(
            price => price.ndc === drug.defaultNdc
          );
          // If a matching price is found, add the loyaltyPrice to the drug object
          if (matchingPrice) {
            drug.loyaltyPrice = matchingPrice.loyaltyPrice;
          }
        });
        setDrugList(drugList);
        return priceDataResp;
      }
    } catch (e) {
      console.log('ERROR while getting getGLPDrugPrices', e);
    } finally {
      setLoading(false);
    }
  };

  const handleSignupModal = () => {
    setSignupModal(true);
    dispatch(modalActions.glpSignupModal());
    let { signUpPath } = _.getSignUpPath(DRUG_RESOURCE_SIGNUP_MODAL);
    _.triggerGTMVirtualPageViewEvent({
      event: 'signUpButtonClick',
      ...signUpPath
    });
  };

  const hideAuthenticateModal = () => {
    setSignupModal(false);
  };

  const getMetaData = () => {
    return (
      <Helmet>
        <title>{data && data.metaTitle}</title>
        <link rel="canonical" href={`${HOME_CANONICAL}/es/recursos`} />
        <meta name="description" content={data && data.metaDescription} />
      </Helmet>
    );
  };

  const handleDrugSearchClick = () => {
    let searchHeaderButton = document.getElementById('mobile-search-icon');
    if (searchHeaderButton) searchHeaderButton.click();
  };

  return (
    <main>
      {getMetaData()}
      <div className="mainResources">
        <div className="resourcesTopSection">
          <div className="middleContainer">
            <div className="drugCollectionNav">
              {data?.SubNavCollection.map((item, index) => {
                return (
                  <a
                    href={item?.urlSlug}
                    key={index}
                    className={
                      item?.drugCollectionName === data.drugCollectionName
                        ? 'active'
                        : ''
                    }
                  >
                    {' '}
                    {item?.drugCollectionName}{' '}
                  </a>
                );
              })}
            </div>
            <SkipTo>
              <h1 className="textCenter">
                <span>{data && data.drugCollectionName}</span> {data?.altH1}
              </h1>
            </SkipTo>

            {documentToReactComponents(JSON.parse(data && data.introText))}
          </div>
        </div>
        <div className="homepage-new">
          {!_.isEmpty(data && data.listOfDrugsTableHeader) && (
            <section className="collectionTable">
              <h2 className="tableHead">
                {data && data.listOfDrugsTableHeader}{' '}
              </h2>
              <table cellPadding="0" cellSpacing="0" className="conditionTable">
                <tr>
                  <th>Drug name</th>
                  <th>
                    <div className="desktop-only">
                      Our lowest price&nbsp;
                      {!isLoggedIn && (
                        <span onClick={() => setSignupModal(true)}>
                          (&nbsp;with free signup&nbsp;)
                        </span>
                      )}
                    </div>
                    <div className="mobile-only">
                      Our lowest price&nbsp;
                      {!isLoggedIn && (
                        <span onClick={() => setSignupModal(true)}>
                          (&nbsp;with signup&nbsp;)
                        </span>
                      )}
                    </div>
                  </th>
                  <th>Coupons</th>
                </tr>
                {drugList.map((drug, index) => {
                  return (
                    <tr className="dataTable" key={index}>
                      <td>
                        <a href={`/prescription/${drug?.seoName}`}>
                          {drug?.drugName}
                        </a>
                      </td>
                      <td>
                        {loading ? 'loading...' : `$${drug?.loyaltyPrice}`}
                      </td>
                      <td>
                        <a
                          href={`/prescription/${drug?.seoName}`}
                          className="sc-btn-pink rx-get-this-price themeFocus"
                        >
                          See all discounts
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </table>
              <div className="collectionSearchContainer">
                <div className="collectionSearch">
                  <div className="searchLeftSection">
                    <h3>Don't see your prescription?</h3>
                    <label>
                      Don’t worry. We have free coupons for thousands of drugs.
                    </label>
                  </div>

                  <div className="searchRightSection">
                    <div className="desktop-only headerSearchBar">
                      <SearchBar tabIndex="5" showZipCode={false} />
                    </div>
                    <div className="mobile-only collectionSearchButton">
                      <button
                        className="sc-btn-pink"
                        onClick={() => handleDrugSearchClick()}
                      >
                        <LazyLoadImage
                          src="../content/images/icons/search.svg"
                          width="24px"
                          height="24px"
                          className="searchIcon"
                        />
                        Search for a drug
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

          <section className="mainContent">
            <div className="mainContentData">
              {documentToReactComponents(JSON.parse(data?.mainContent))}
            </div>
          </section>

          {!isLoggedIn && (
            <div className="homeSignupSection">
              <HomeSignUpv2
                showLeftSection={false}
                openSignupModal={handleSignupModal}
              />
            </div>
          )}

          {!_.isEmpty(data && data.listOfDrugs2) && (
            <div className="collectionTable2">
              <h2 className="tableHead">{data && data.listOfDrugsHeader2}</h2>
              <table cellPadding="0" cellSpacing="0" className="conditionTable">
                <tr>
                  <th>Drug name</th>
                  <th>Coupons</th>
                </tr>
                {data.listOfDrugs2.map((drug, index) => {
                  return (
                    <tr className="dataTable" key={index}>
                      <td>
                        <a href={`/prescription/${drug?.seoName}`}>
                          {drug?.drugName}
                        </a>
                      </td>
                      <td>
                        <a
                          href={`/prescription/${drug?.seoName}`}
                          className="sc-btn-pink rx-get-this-price themeFocus"
                        >
                          See all discounts
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          )}

          {!_.isEmpty(data && data.listOfDrugs3) && (
            <div className="collectionTable2">
              <h2 className="tableHead">{data && data.listOfDrugsHeader3}</h2>
              <table cellPadding="0" cellSpacing="0" className="conditionTable">
                <tr>
                  <th>Drug name</th>
                  <th>Coupons</th>
                </tr>
                {data.listOfDrugs3.map((drug, index) => {
                  return (
                    <tr className="dataTable" key={index}>
                      <td>
                        <a href={`/prescription/${drug?.seoName}`}>
                          {drug?.drugName}
                        </a>
                      </td>
                      <td>
                        <a
                          href={`/prescription/${drug?.seoName}`}
                          className="sc-btn-pink rx-get-this-price themeFocus"
                        >
                          See all discounts
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          )}

          {isSignupModalOpen && (
            <div className="mainModal afterSignupmodal">
              <div
                className="transparentBg"
                onClick={() => setSignupModal(false)}
              ></div>
              <div className="signUpModal">
                <AuthenticatedModal
                  skipEmailScreen={false}
                  hideAuthenticateModal={hideAuthenticateModal}
                />
              </div>
            </div>
          )}
          <div
            id="prescription-monograph-data"
            className="prescription-monograph-data"
          >
            <section id="faqs">
              <ContentfulFaqs drugInfo={cmsData} heading={data?.faqHeader} />
            </section>
          </div>
          <section id="news-research">
            {!_.isEmpty(data?.blogs) && (
              <RelatedArticles
                blogData={data?.blogs}
                drugName={data?.drugCollectionName}
                heading={
                  data?.featuredContentHeader ||
                  (data?.drugCollectionName
                    ? `${data.drugCollectionName} Guides`
                    : '')
                }
              />
            )}
          </section>
          {data && !_.isEmpty(data?.relatedConditions) && (
            <RelatedList
              heading={
                data?.relatedConditionsH2
                  ? data?.relatedConditionsH2
                  : 'Related Conditions'
              }
              slugPrefix={RELATED_ITEM_SLUG_PREFIX.CONDITIONS_PAGE}
              slugType={RELATED_ITEM_SLUG_KEY.SLUG}
              isLimited={false}
              relatedData={data?.relatedConditions}
              id="related-conditions"
            />
          )}
          {data && !_.isEmpty(data?.relatedDrugClasses) && (
            <RelatedList
              heading={
                data?.relatedDrugClassesH2
                  ? data?.relatedDrugClassesH2
                  : 'Related Drug Classes'
              }
              slugPrefix={RELATED_ITEM_SLUG_PREFIX.DRUG_CLASSES_PAGE}
              slugType={RELATED_ITEM_SLUG_KEY.SLUG}
              isLimited={false}
              relatedData={data?.relatedDrugClasses}
              id="related-drug-classes"
            />
          )}
        </div>
        {data && !_.isEmpty(data?.sources) && (
          <section className="mainContent">
            <div className="mainContentData">
              {documentToReactComponents(JSON.parse(data?.sources))}
            </div>
          </section>
        )}
      </div>
    </main>
  );
};
export default DrugCollectionDetails;
